import { ref, computed } from 'vue'
import { defineStore } from 'pinia'

export const useAcquisitionStore = defineStore('acquisition', () => {
  // State
  // ----------------------
  const acquisition = ref({})

  const testingCookie = useCookie('testing', { readonly: true })

  // Getters
  // ----------------------
  const isEmpty = computed(() => !Object.values(acquisition.value).some(Boolean))

  // Actions
  // ----------------------
  function setAcquisitionParams (queryParams = {}) {
    acquisition.value.source = queryParams.utm_source
    acquisition.value.medium = queryParams.utm_medium
    acquisition.value.campaign = queryParams.utm_campaign
    acquisition.value.content = queryParams.utm_content
    acquisition.value.term = queryParams.utm_term
    acquisition.value.keyword = queryParams.utm_kw
    acquisition.value.affiliate = queryParams.utm_affiliate
    acquisition.value.awc = queryParams.awc

    // Clean empty data.
    for (const key in acquisition.value) {
      if (!acquisition.value[key]) {
        delete acquisition.value[key]
      }
    }
  }

  function getAcquisitionData () {
    if (typeof testingCookie.value !== 'object' || Object.keys(testingCookie.value).length === 0 || testingCookie.value === null) {
      return acquisition.value
    }

    const testCookieString = Object.entries(testingCookie.value)
      .map(([key, value]) => `${key}-${value}`)
      .join('/')

    return {
      ...acquisition.value,
      test: testCookieString,
    }
  }

  return {
    acquisition,
    isEmpty,
    setAcquisitionParams,
    getAcquisitionData,
  }
})
